import React, { Fragment, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import styles from "./Checkout.module.scss";
import NumberFormat from "react-number-format";

const CustomerInfo = ({ app = false, isSeniorBooking = false, register, errors, control, setValue, trigger, customer, watch }) => {
  const [phone, setPhone] = useState(customer.phone || '');
  useEffect(() => {
    if (customer.phone) {
      setPhone(customer.phone);
      setValue('phone', customer.phone);
    }
  }, [customer]);

  return (
    <Fragment>
      <h1 className={styles.header}>
        {isSeniorBooking ? 'Contact Information' : `${app ? '2' : '1'}. Contact Information`}
      </h1>
      <label className={styles.label}>Parent/Guardian First Name: <span className={styles.requiredMark} aria-hidden="true">*</span></label>
      <input
        defaultValue={customer.firstName}
        aria-required="true"
        className={`${styles.input} ${errors.first_name && styles.error}`}
        {...register("first_name", { required: "First name is required" })}
      />
      {errors.first_name && <p className={styles.errorMessage}>{errors.first_name.message || 'First name is required'}</p>}

      <label className={styles.label}>Parent/Guardian Last Name: <span className={styles.requiredMark} aria-hidden="true">*</span></label>
      <input
        defaultValue={customer.lastName}
        aria-required="true"
        className={`${styles.input} ${errors.last_name && styles.error}`}
        {...register("last_name", { required: "Last name is required" })}
      />
      {errors.last_name && <p className={styles.errorMessage}>{errors.last_name.message || 'Last name is required'}</p>}

      <label className={styles.label}>Email: <span className={styles.requiredMark} aria-hidden="true">*</span></label>
      <input
        type="email"
        defaultValue={customer.email}
        aria-required="true"
        className={`${styles.input} ${errors.email && styles.error}`}
        {...register("email", {
          required: "Email is required",
          pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Please enter a valid email address" },
        })}
      />
      {errors.email && <p className={styles.errorMessage}>{errors.email.message || 'Email is required'}</p>}

      <label className={styles.label}>Phone # <span className={styles.requiredMark} aria-hidden="true">*</span></label>
      <Controller
        control={control}
        name="phone"
        render={({ value }) => (
          <NumberFormat
            format="+1 (###) ###-####"
            allowEmptyFormatting mask="_"
            defaultValue={phone}
            className={`${styles.input} ${errors.phone && styles.error}`}
            inputMode='numeric'
            value={value}
            onValueChange={(v) => {
              setValue('phone', v.value);
              if (errors.phone) trigger('phone');
            }}
          />
        )}

        rules={{ required: "Phone number is required", minLength: { value: 10, message: "Phone number must be at least 10 digits" } }}
      />
      {errors.phone && <p className={styles.errorMessage}>{errors.phone.message || 'Phone number is required'}</p>}

      <label className={styles.label}>Notes:</label>
      <textarea
        className={styles.input}
        {...register("notes", { required: false })}
      />
    </Fragment>
  )
}

export default CustomerInfo;
